import type FieldDraft from '@UI/Pages/Subjects/Shared/FormData/FieldDraft';
import isFieldDraftEmpty from '@UI/Pages/Subjects/Shared/FormData/constraint/isFieldDraftEmpty';
import type SubjectFieldDefinitionView from '@UI/Store/SubjectTypes/Views/SubjectFieldDefinitionView';

const INVALID_MESSAGES: Readonly<Record<string, string>> = Object.freeze({
	text: 'Saisissez un texte de 255 caractères au plus.',
	long_text: 'Saisissez un texte de 5 000 caractères au plus.',
	date: 'Saisissez une date valide.',
	number: 'Saisissez un nombre.',
	boolean: 'Choisissez oui ou non.',
	choice: 'Choisissez une option proposée.',
	multiple_choice: 'Choisissez une ou plusieurs options proposées.',
});

const FALLBACK_MESSAGE = 'La valeur saisie est invalide.';

/** The message of an invalid draft; the wording is the server's, so both sides say the same thing. */
const resolveFieldValueMessage = (definition: SubjectFieldDefinitionView, draft: FieldDraft): string => {
	if (isFieldDraftEmpty(draft)) {
		return 'Ce champ est requis.';
	}

	return INVALID_MESSAGES[definition.nature] ?? FALLBACK_MESSAGE;
};

export default resolveFieldValueMessage;
